import { useEffect } from 'react';
/*
 * Note: This is necessary for when we open the Questionnaire modal from MMA Activity modal.
 * We should find another way to handle the overflow scrolling defect from the Component Library
 */
var useDDPreventScroll = function () {
    var ddPreventScroll = 'dd-prevent-scroll';
    useEffect(function () {
        document.body.classList.add(ddPreventScroll);
        return function () {
            document.body.classList.remove(ddPreventScroll);
        };
    }, []);
};
export default useDDPreventScroll;
//# sourceMappingURL=useDDPreventScrolling.js.map